<template>
	<div class="common-layout left-right-content">
	    <el-container>
	      <el-header class="main-header-tool" style="padding: 0 20px 0 0;">
			  <div style="margin-right: auto;">
				  <img style="width: 200px; height: 120px" src="../static/walker.jpg" fit="fill" ></img>
			  </div>
			  <div class="toolbar">
				<el-icon :size="20" style="margin-right: 15px" @click="setOrderItem"><setting color="#fff"/></el-icon>
				<el-icon :size="20" style="margin-right: 15px" @click="setMiniItem"><setting color="#fff"/></el-icon>
			    <el-dropdown>
			      <el-icon :size="20" style="margin-right: 15px;"><Avatar color="#fff"/></el-icon>
			      <template #dropdown>
			        <el-dropdown-menu >
			          <el-dropdown-item @click="hrmList">人事管理</el-dropdown-item>
			          <el-dropdown-item @click="modifyPass">修改密码</el-dropdown-item>
			          <el-dropdown-item @click="logout">退出</el-dropdown-item>
			        </el-dropdown-menu>
			      </template>
			    </el-dropdown>
			    <span> {{ userStore.profile?.name }} </span>
			  </div>
		  </el-header>
	      <el-container>
	        <el-aside class="left-content">
				<el-scrollbar height="800px">
					<el-menu
						active-text-color="#ffd04b"
						default-active="1"
						class="el-menu-vertical-demo"
						:router="true"
						@open="handleOpen"
						@close="handleClose"
					  >
						<el-sub-menu index="1">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>订单管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/index/jsj-order-add">订单录入</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/index/jsj-order-list">录入订单信息</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/index/orders-list">订单查询-新</el-menu-item>
						  <!-- <el-menu-item class="sub-menu-fontsize" index="/index/jsj-jj-order">旧版本订单查询</el-menu-item> -->
						</el-sub-menu>
						<el-sub-menu index="11">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>Klook客路相关</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/car/car-calendar-list">车辆日历</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/klook/car-list">车辆管理</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/klook/driver-list">司机管理</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/klook/orders-list">订单管理</el-menu-item>
						</el-sub-menu>
						<el-sub-menu index="2">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>小程序车辆管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/car/cate-add">新增车辆分类</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/car/cate-manage">车型分类管理</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/car/car-add">新增车辆类型</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/car/car-manage">车辆类型管理</el-menu-item>
						</el-sub-menu>
						<el-sub-menu index="3">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>司机订单管理</span>
						  </template>
						  <!-- <el-menu-item class="sub-menu-fontsize" index="/driver/driver-add">新增司机</el-menu-item> -->
						  <!-- <el-menu-item class="sub-menu-fontsize" index="/driver/dssriver-manage">司机查询</el-menu-item> -->
						  <el-menu-item class="sub-menu-fontsize" index="/driver/driver-order">司机订单</el-menu-item>
						</el-sub-menu>
			<!-- 			<el-sub-menu index="4">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>客服管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/kf/kf-add">新增客服</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/kf/kf-manage">查询客服</el-menu-item>
						</el-sub-menu> -->
						<el-sub-menu index="5">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>优惠券管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/coupon/coupon-add">新增优惠券</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/coupon/coupon-manage">查询优惠券</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/coupon/coupon-granted">已发放优惠券</el-menu-item>
						</el-sub-menu>
						<el-sub-menu index="6">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>司机注册审核</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/dregister/register-todo?type=todo">待审核</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/dregister/register-pass?type=passed">审核通过</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/dregister/register-nopass?type=nopass">审核退回</el-menu-item>
						</el-sub-menu>
						<el-sub-menu index="7">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>酒店预定管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/mall/good-add">添加房间</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/mall/good-list">房间查询</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/mall/good-orders-list">预订查询</el-menu-item>
						</el-sub-menu>
						<!-- <el-sub-menu index="8">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>咨询管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/consult/consult-list">咨询机构</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/consult/consult-info-list">咨询人员</el-menu-item>
						</el-sub-menu> -->
						<el-sub-menu v-if="userStore.profile?.departmentid===1||userStore.profile?.departmentid===2||userStore.profile?.userid===2" index="10">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>积分申请</span>
						  </template>
						  <el-menu-item v-if="userStore.profile?.departmentid===1" class="sub-menu-fontsize" index="/integral/apply-add">新建申请</el-menu-item>
						  <el-menu-item v-if="userStore.profile?.departmentid===1||userStore.profile?.departmentid===2||userStore.profile?.userid===2" class="sub-menu-fontsize" index="/integral/apply-manage">待办/已办</el-menu-item>
						</el-sub-menu>
						<!-- <el-sub-menu index="9">
						  <template #title>
							<el-icon><Menu /></el-icon>
							<span>医美管理</span>
						  </template>
						  <el-menu-item class="sub-menu-fontsize" index="/medical/hospital-add">添加诊所</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/medical/hospital-list">诊所列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/spa-info/spa-add">添加SPA</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/spa-info/spa-list">SPA列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/restaurant/restaurant-add">添加餐厅</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/restaurant/restaurant-list">餐厅列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/doctor/doctor-add">添加医师</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/doctor/doctor-list">医师列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/news/news-add">添加资讯</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/news/news-list">资讯列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/scene-info/scene-add">添加热门景点</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/scene-info/scene-list">热门景点列表</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/comment/comment-list">评论注解</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/dictionary/dictionary-add">新增词典</el-menu-item>
						  <el-menu-item class="sub-menu-fontsize" index="/dictionary/dictionary-list">词典列表</el-menu-item>
						</el-sub-menu> -->
					  </el-menu>
				</el-scrollbar>
			</el-aside>
	        <el-container>
	          <el-main class="right-content">
				  <RouterView />
			  </el-main>
	        </el-container>
	      </el-container>
	    </el-container>
	  </div>
	  <el-dialog
	      v-model="setDialogVisible"
	      title="小程序显示模块设置"
	      width="50%"
	      destroy-on-close
		  :modal="false"
		>
		<div style="display: flex;justify-content: center;align-items: center;margin-bottom: 12px;" v-for="(item,index) in settings" :key='index'>
			<div style="width:70% ;">
				<el-input v-model="item.mkmc" style="width: 360px" placeholder="请输入模块名称" />
			</div>
			<div style="width:30% ;">
				<el-radio-group v-model="item.sfkq">
					<el-radio border label="启用" value="0"/>
					<el-radio border label="禁用" value="1"/>
				</el-radio-group>
			</div>
		</div>
	  	<template #footer>
	  	  <span class="dialog-footer">
	  	    <el-button @click="cancelSettings">取消</el-button>
			<el-button type="primary" @click="saveSettings">保存</el-button>
			<el-button type="primary" @click="addSettings">新增</el-button>
	  	  </span>
	  	</template>
	  </el-dialog>
	  <el-dialog
	      v-model="orderSetDialogVisible"
	      title="订单预警设置"
	      width="70%"
	      destroy-on-close
	  		  :modal="false"
	  		>
			<!-- 提醒邮箱设置 -->
			<div  style="display: flex;justify-content: center;align-items: center;margin-bottom: 12px;">
				<el-input-tag
				    v-model="emails"
				    placeholder="请输入提醒邮箱"
				    aria-label="按Enter回车键添加输入内容为标签"
				  />
			</div>
	  		<div style="display: flex;justify-content: center;align-items: center;margin-bottom: 12px;" v-for="(item,index) in orderSettings" :key='index'>
	  			<div style="width:75% ;">
	  				车型：<el-select v-model="item.cartype" placeholder="请选择" style="width: 240px">
	  				    <el-option
	  				      v-for="opItem in options"
	  				      :key="opItem.value"
	  				      :label="opItem.label"
	  				      :value="opItem.value"
	  				    />
	  				  </el-select>
					可用数量：<el-input v-model="item.amount" style="width: 150px" placeholder="可用数量" />
					预警比例：<el-input v-model="item.userate" type="number" style="width: 150px" placeholder="开始预警比例" />
	  			</div>
	  			<div style="width:25% ;">
	  				是否启用：<el-radio-group v-model="item.valide">
	  					<el-radio border label="启用" value="0"/>
	  					<el-radio border label="禁用" value="1"/>
	  				</el-radio-group>
	  			</div>
	  		</div>
	  	<template #footer>
	  	  <span class="dialog-footer">
	  	    <el-button @click="cancelOrderSettings">取消</el-button>
			<el-button type="primary" @click="saveOrderSettings">保存</el-button>
			<el-button type="primary" @click="addOrderSettings">新增</el-button>
	  	  </span>
	  	</template>
	  </el-dialog>
	  <el-dialog
	      v-model="passDialogVisible"
	      title="修改密码"
	      width="50%"
	      destroy-on-close
	  	  :modal="false"
	  >
	  	<el-form
	  	    ref="ruleFormRef"
	  	    :model="sizeForm"
	  	    label-width="auto"
	  	    :label-position="labelPosition"
	  	    :size="size"
	  		:rules="rules"
	  	>
	  		<div style="display: flex;">
	  			<el-form-item label="当前密码" style="width: 96%;" prop="oldPassword">
	  			  <el-input v-model="sizeForm.oldPassword" class="w-50 m-2" type="password" placeholder="请输入当前密码" show-password  autocomplete="off"/>
	  			</el-form-item>
	  		</div>
	  		<div style="display: flex;">
	  			<el-form-item label="新密码" style="width: 96%;" prop="password">
	  			  <el-input v-model="sizeForm.password" class="w-50 m-2" type="password" placeholder="请输入新密码" show-password  autocomplete="off"/>
	  			</el-form-item>
	  		</div>
	  		<div style="display: flex;">
	  			<el-form-item label="确认密码" style="width: 96%;" prop="rpassword">
	  			  <el-input v-model="sizeForm.rpassword" class="w-50 m-2" type="password" placeholder="请确认密码" show-password autocomplete="off"/>
	  			</el-form-item>
	  		</div>
	  	</el-form>
	  	<template #footer>
	  	  <span class="dialog-footer">
	  	    <el-button @click="passDialogVisible = false">关闭</el-button>
	  	    <el-button type="primary" @click="saveNewPass">保存</el-button>
	  	  </span>
	  	</template>
	  </el-dialog>
</template>
<script setup>
	import { useMemberStore } from '../stores';
	import { computed,ref } from 'vue'
	import axios from 'axios';
	import { useRoute, useRouter } from 'vue-router'
	import { ElMessage } from 'element-plus'
	const orderSetDialogVisible = ref(false)
	const cancelOrderSettings=()=>{
		orderSetDialogVisible.value = false;
	}
	const addOrderSettings=()=>{
		orderSettings.value.push({
			billid: '',
			cartype: '',
			carname: '',
			amount:0,
			userate:0,
			valide:"0"
		})
	}
	const orderSettings = ref([])
	const value = ref('')
	const options = [
	  {
	    value: '77',
	    label: '豪7',
	  },
	  {
	    value: '80',
	    label: '舒11',
	  },
	  {
	    value: '81',
	    label: '舒9',
	  },
	  {
	    value: '82',
	    label: '舒5',
	  },
	  {
	    value: '83',
	    label: '经9',
	  },
	  {
	    value: '84',
	    label: '经7',
	  },
	  {
	    value: '85',
	    label: '经5',
	  }
	]
	const optionsObj = {
		"77":"豪7",
		"80":"舒11",
		"81":"舒9",
		"82":"舒5",
		"83":"经9",
		"84":"经7",
		"85":"经5"
	}
	const saveOrderSettings=()=>{
		let isSuccess = false
		orderSettings.value.forEach(async(item,index)=>{
			const res = await axios.post('/orderManageSet/info/saveOrUpdate', {
				billid:item.id,
				emails:JSON.stringify(emails.value),
				cartype:item.cartype,
				carname:optionsObj[`${item.cartype}`],
				amount:item.amount,
				userate:item.userate,
				valide:item.valide,
				is_delete:0
			}, {
			  headers: {
			    'Content-Type': 'application/json',
				Authorization: `${userStore.profile?.token}`,
			  }
			});
			if(res.data.status===0&&!isSuccess){
				isSuccess = true
				ElMessage.success('保存成功!')
			}
		})
		orderSetDialogVisible.value = false
	}
	const emails = ref([])
	const size = ref('default')
	const labelPosition = ref('right')
	const ruleFormRef = ref(null)
	const passDialogVisible = ref(false)
	const validateOldPass = async(rule, value, callback) => {
	  if (value !== '') {
		//查询接口 账号是否已被占用
		const response = await axios.post('/hrm/user/verifyPass', {
		  billid:userStore.profile?.userid,
		  password:sizeForm.value.oldPassword
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===1){
			callback(new Error(response.data.msg))
		}else if(response.data.status===0&&!response.data.msg){
			callback(new Error("原密码不正确。"))
		}
	   } else {
			callback()
	  }
	}
	const validatePass = (rule, value, callback) => {
	  if (value === '') {
	    callback(new Error('请输入密码'))
	  } else {
	    callback()
	  }
	}
	const validatePass2 = (rule, value, callback) => {
	  if (value === '') {
	    callback(new Error('请再次输入密码'))
	  } else if (value !== sizeForm.value.password) {
	    callback(new Error("2次输入密码不一致!"))
	  } else {
	    callback()
	  }
	}
	const rules = ref({
	  password: [{ validator: validatePass, trigger: 'blur' }],
	  rpassword: [{ validator: validatePass2, trigger: 'blur' }],
	  oldPassword:[{ validator: validateOldPass, trigger: 'blur' }],
	})
	const sizeForm = ref({
		oldPassword:'',
		password:'',
		rpassword:'',
	});
	const saveNewPass=()=>{
		ruleFormRef.value.validate(async valid=>{
			if(valid){
				const response = await axios.post('/hrm/user/modifyPass', {
				  billid:userStore.profile?.userid,
				  password:sizeForm.value.password
				}, {
				  headers: {
					'Content-Type': 'application/json',
					Authorization: `${userStore.profile?.token}`,
				  }
				});
				if(response.data.status===0){
					ElMessage.success('修改成功!')
					sizeForm.value = {}
					passDialogVisible.value = false
				}
			}else{
				ElMessage.error('校验不通过!')
			}
		})
	}
	const setDialogVisible = ref(false)
	const settings = ref([])
	
	const router = useRouter();
	const route = useRoute();
	
	const hrmList=()=>{
		// router.push('/hrm/user-list');
		router.push('/hrm/department-tree');
	}
	
	const modifyPass=()=>{
		//弹框修改密码
		passDialogVisible.value = true
	}

	const userStore = useMemberStore();
	const logout = ()=>{
		userStore.clearProfile();
		router.push('/login'); // 退出后跳转到登录页面
	}
	const handleOpen = (key, keyPath) => {
	  console.log(key, keyPath)
	}
	const handleClose = (key, keyPath) => {
	  console.log(key, keyPath)
	}
	const setOrderItem=async()=>{
		orderSetDialogVisible.value = true;
		const res = await axios.post('/orderManageSet/info/queryList', {
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0){
			orderSettings.value = res.data.data;
			if(res.data.data?.length>0&&res.data.data[0].emails){
				emails.value = JSON.parse(res.data.data[0].emails) 
			}
		}
	}
	const setMiniItem=async()=>{
		setDialogVisible.value = true;
		const res = await axios.post('/api/mini/settings', {
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0){
			settings.value = res.data.data;
		}
	}
	const cancelSettings=()=>{
		setDialogVisible.value = false;
	}
	const saveSettings=async()=>{
		const res = await axios.post('/api/mini/saveSettings', {
			settings: JSON.stringify(settings.value) 
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		ElMessage.success('保存成功!');
		setDialogVisible.value = false;
	}
	const addSettings=async()=>{
		const res = await axios.post('/api/mini/addSettings', {
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0){
			settings.value.push({
				id: res.data.data.insertId,
				mkmc: '新增模块',
				sfkq: '0'
			})
		}
	}
</script>

<style scoped>
	.main-header-tool{
		display: flex; /* 设置为flex布局 */
		justify-content: flex-end;
		align-items: center;
		background-color: #545c64;
		color: #fff;
		font-size: 18px;
	}
	.left-right-content{
		display: flex;
		height: 675px;
	}
	.left-content{
		width: 200px;
		height: 100%;
	}
	.right-content{
		width: calc(100%-200px);
		height: 100%;
	}
	.sub-menu-fontsize{
		font-size: 14px; /* 设置子菜单的字体大小 */
	}
</style>